import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetLastAccess, HttpGetLastAccessOptions, HttpGetLastAccessResponse} from '../http/accesses.http'

export const useGetLastAccess = ({
    params,
    options
}: {
    params: HttpGetLastAccessOptions['params']
    options?: Omit<UseQueryOptions<HttpGetLastAccessResponse>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.ACCESSES, params.projectId, params.groupName],
        queryFn: () => httpGetLastAccess({params}),
        ...options
    })
